import { render, staticRenderFns } from "./codeRegister.vue?vue&type=template&id=46c97a92&scoped=true&"
import script from "./codeRegister.vue?vue&type=script&lang=js&"
export * from "./codeRegister.vue?vue&type=script&lang=js&"
import style0 from "./codeRegister.vue?vue&type=style&index=0&id=46c97a92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c97a92",
  null
  
)

export default component.exports